(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('favourite-filter', {
            parent: 'entity',
            url: '/favourite-filter?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.favouriteFilter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/favourite-filter/favourite-filters.html',
                    controller: 'FavouriteFilterController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('favouriteFilter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('favourite-filter-detail', {
            parent: 'entity',
            url: '/favourite-filter/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.favouriteFilter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/favourite-filter/favourite-filter-detail.html',
                    controller: 'FavouriteFilterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('favouriteFilter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FavouriteFilter', function($stateParams, FavouriteFilter) {
                    return FavouriteFilter.get({id : $stateParams.id});
                }]
            }
        })
        .state('favourite-filter.new', {
            parent: 'favourite-filter',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/favourite-filter/favourite-filter-dialog.html',
                    controller: 'FavouriteFilterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                viewName: null,
                                name: null,
                                kendoOptions: null,
                                masterOptions: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('favourite-filter', null, { reload: true });
                }, function() {
                    $state.go('favourite-filter');
                });
            }]
        })
        .state('favourite-filter.edit', {
            parent: 'favourite-filter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/favourite-filter/favourite-filter-dialog.html',
                    controller: 'FavouriteFilterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FavouriteFilter', function(FavouriteFilter) {
                            return FavouriteFilter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('favourite-filter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('favourite-filter.delete', {
            parent: 'favourite-filter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/favourite-filter/favourite-filter-delete-dialog.html',
                    controller: 'FavouriteFilterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FavouriteFilter', function(FavouriteFilter) {
                            return FavouriteFilter.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('favourite-filter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
